module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploader"
  }, [_vm._t("default", [_c('uploader-unsupport'), _vm._v(" "), _c('uploader-drop', [_c('p', [_vm._v("Drop files here to upload or")]), _vm._v(" "), _c('uploader-btn', [_vm._v("select files")]), _vm._v(" "), _c('uploader-btn', {
    attrs: {
      "directory": true
    }
  }, [_vm._v("select folder")])], 1), _vm._v(" "), _c('uploader-list')], {
    files: _vm.files,
    fileList: _vm.fileList,
    started: _vm.started
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78afdef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader.vue
// module id = 75
// module chunks = 0